import { useTheme } from '@approvalmax/theme';
import { ChevronRightIcon } from '@approvalmax/ui';
import { Box, Flex, Text } from '@approvalmax/ui/src/components';
import { memo } from 'react';
import { useMedia } from 'react-use';

import { useBoardNavItems } from '../../hooks/useBoardNavItems';
import { Loading } from './BoardsList.loading';
import { messages } from './BoardsList.messages';
import { Item } from './BoardsList.styles';

export const BoardsList = memo(() => {
    const { items: boardNavItems, isInitialLoading } = useBoardNavItems();

    const { theme } = useTheme();
    const isSmallScreen = useMedia(`(max-width: ${theme.container.breakpoint.medium})`);

    if (!boardNavItems.length) return null;

    return isInitialLoading ? (
        <Loading />
    ) : (
        <Flex justifyContent='center'>
            <Box width={isSmallScreen ? undefined : theme.container.content.small} spacing='16 0 0'>
                <Text font='headline' fontSize='large' as='h1' spacing='0 0 24'>
                    {messages.title}
                </Text>

                <Flex container spacing='16 40'>
                    {boardNavItems.map(({ value, label, to, postCount }) => (
                        <Flex size={12} key={value}>
                            <Item to={to}>
                                <Flex alignItems='center' justifyContent='space-between' spacing='8'>
                                    <Text font='label' fontSize='large'>
                                        {label}
                                    </Text>

                                    <Flex alignItems='center' spacing='8'>
                                        <Text font='label' fontSize='large' color='midnight70'>
                                            {postCount}
                                        </Text>

                                        <ChevronRightIcon size={12} color='midnight80' />
                                    </Flex>
                                </Flex>
                            </Item>
                        </Flex>
                    ))}
                </Flex>
            </Box>
        </Flex>
    );
});

BoardsList.displayName = 'BoardsList';
